/**
 *
 * 編輯器與文章頁各 Element 樣式會統一放在這邊
 *
 * 樣式 Spec - https://www.figma.com/file/kfYGvgYParI87GrsXWIU8A/Web-%2F-%5BWeb3.0%5D-%E5%85%A7%E6%96%87%E9%A0%81?node-id=644%3A0
 *
 */

import { css } from 'styled-components'
import { theme } from 'twin.macro'

/**
 * 內文 <p>
 */
export const paragraph = css`
  color: ${theme`colors.black`};
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0.25px;
  margin: 16px 0;

  @media (min-width: ${theme`screens.md`}) {
    font-size: 18px;
  }
`

export const h1 = css`
  color: ${theme`colors.black`};
  font-size: 24px;
  line-height: 135%;
  font-weight: 600;

  @media (min-width: ${theme`screens.md`}) {
    font-size: 34px;
    letter-spacing: -0.5px;
  }
`

export const heading = css`
  color: ${theme`colors.black`};
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: -0.5px;
  margin: 16px 0;

  @media (min-width: ${theme`screens.md`}) {
    font-size: 28px;
    line-height: 135%;
    letter-spacing: 0.5px;
  }
`

/**
 * 副標 <h2>
 */
export const h2 = heading

/**
 * 副標 <h3>
 */
export const h3 = css`
  color: ${theme`colors.black`};
  font-weight: 600;
  font-size: 18px;
  line-height: 135%;
  margin: 16px 0;

  @media (min-width: ${theme`screens.md`}) {
    font-size: 24px;
    line-height: 135%;
  }
`

/**
 * 超連結：<a>
 */
export const link = css`
  color: ${theme`colors.primary.normal`};
  text-decoration: none;
  margin-inline-end: 0.5ch;

  &:hover,
  &:active {
    color: ${theme`colors.primary.darkGrey`};
  }
`

/**
 * 粗體 <b> <strong>
 */
export const bold = css`
  font-weight: 600;
`

/**
 * 引用 <blockquote>
 */
export const quote = css`
  padding-left: 16px;
  border-left: 3px solid ${theme`colors.primary.normal`};
  margin-block: 16px;
`

/**
 * 螢光筆 <mark>
 */
export const marker = css`
  background-color: #eaeaff;
`

/**
 * 分隔線
 *
 * 舊樣式來源 -> https://github.com/popdaily/popdaily.server/blob/52818d0596b933018bb8a94d557379d31bc38cee/src/component/Post/index.scss#L241-L253
 * 參考檔案位置 -> web/src/features/post/components/WebPost.scss#L220
 *
 * 為了長得 Editor.js 的分隔線一樣而採用這樣的處理
 */
export const delimiter = css`
  width: 100%;
  line-height: 78px;
  height: 78px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  span {
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background-color: #666666;
  }

  span + span {
    margin-left: 12px;
  }
`

/**
 * ul 與 ol
 */
export const list = css`
  padding-left: 30px;

  li {
    ${paragraph}
  }
`
